import React from 'react';
import {Button}                           from 'antd';


import './ModalB.scss';

const modalB =(props) =>{
    let classes="deactive";

    if(props.show){
        classes="Modal"
    }

    let objectToArray = Object.values(props.text)

    let texts = objectToArray.map(eachTxt =>{
        return (
            <p>{eachTxt}</p>
        )
    })

    const button = props.button != "" ?
    <Button className="button" onClick={props.close} >{props.button}</Button>
    : null;

    
    return (
        
        <div className={classes}>
            <div className="icon">
                <img src={props.icon}/>
            </div>
            <header>
                <h2>{props.header}</h2>
            </header>
            <article>
                {texts}
            </article>
            <footer>
                {button}
            </footer>
        </div>
    );
    
}



export default modalB;